<template>
  <div style="background-color: white" v-if="loading">
    <loader />
  </div>
  <div v-if="!loading" id="printable_div" class="lab-details-container">
    <!-- 🔹 Patient BioData Card -->
    <section class="patient-card">
      <h3>Patient BioData</h3>
      <div class="biodata-grid">
        <div class="biodata-item">
          <span class="label">Patient ID:</span>
          <span class="value">{{
            "OPD/" + opd.opd + " || " + " IPD/" + opd.ipd
          }}</span>
        </div>
        <div class="biodata-item">
          <span class="label">Full Name:</span>
          <span class="value">{{ patient.name }}</span>
        </div>
        <div class="biodata-item">
          <span class="label">Date of Birth:</span>
          <span class="value">{{ patient.dob }}</span>
        </div>
        <!-- <div class="biodata-item">
          <span class="label">Age:</span>
          <span class="value">{{ patient.age }}</span>
        </div> -->
        <div class="biodata-item">
          <span class="label">Gender:</span>
          <span class="value">{{
            patient.gender == 1 ? "Male" : "Female"
          }}</span>
        </div>
        <div class="biodata-item">
          <span class="label">Phone:</span>
          <span class="value">{{ patient.phone }}</span>
        </div>
        <div class="biodata-item">
          <span class="label">Email:</span>
          <span class="value">{{ patient.email }}</span>
        </div>
        <div class="biodata-item">
          <span class="label">Address:</span>
          <span class="value">{{ patient.location }}</span>
        </div>
        <!-- <div class="biodata-item">
          <span class="label">MRN:</span>
          <span class="value">{{ patient.mrn }}</span>
        </div>
        <div class="biodata-item">
          <span class="label">Insurance:</span>
          <span class="value">{{ patient.insurance }}</span>
        </div> -->
      </div>
    </section>

    <!-- 🔹 Test Name Header -->
    <section class="test-header">
      <h2>{{ service.service_name }}</h2>
      <p class="test-meta">
        Test ID: {{ service.id || "N/A" }} • Status:

        <span v-if="service.attended == 0" :class="statusClass">Pending</span>
        <span v-if="service.attended == 1" :class="statusClass"
          >In Progress</span
        >
        <span v-if="service.attended == 2" :class="statusClass">Completed</span>
      </p>
    </section>

    <!-- 🔹 Action Buttons -->
    <div v-if="visit.visit_status != 'ended'" class="action-bar exclude-print">
      <button v-if="service.attended == 0" @click="display_initiate_lab_modal">
        Start Test
      </button>
      <button v-if="service.attended != 0" @click="display_initiate_lab_update">
        Update Test & Specimen Data
      </button>
      <button v-if="service.attended == 1" @click="show_test_tesult_modal_">
        Complete Test & Save Results
      </button>

      <button v-if="service.attended == 2" @click="show_test_tesult_modal_">
        Edit Results
      </button>
      <!-- <button @click="saveResults">Save Results</button> -->

      <button @click="goBack">Go Back to Tests List</button>
      <button @click="printReport">Print Report</button>
    </div>

    <div v-if="visit.visit_status == 'ended'" class="action-bar exclude-print">
      <button @click="printReport">Print Report</button>
    </div>

    <div
      v-if="service.attended == 0"
      style="background-color: #e3f2fd; color: black"
    >
      <span style="margin-left: 40%; font-size: 1.2em"
        >...No test data yet...</span
      >
    </div>

    <!-- 🔹 Main Grid -->
    <div v-if="service.attended != 0" class="grid-layout">
      <!-- Specimen Info -->
      <section class="card">
        <h3>Specimen Info</h3>
        <div class="info-row">
          <span class="label">Specimen ID</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.specimen_id || specimen.id }}</span
          >
        </div>
        <div class="info-row">
          <span class="label">Type</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.type }}</span
          >
        </div>
        <div class="info-row">
          <span class="label">Collection Date</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.collection_date }}</span
          >
        </div>
        <div class="info-row">
          <span class="label">Condition</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.condition }}</span
          >
        </div>
        <div class="info-row">
          <span class="label">Collector</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.collector }}</span
          >
        </div>
        <div class="info-row">
          <span class="label">Storage</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.storage }}</span
          >
        </div>
      </section>

      <!-- Test Details -->
      <section class="card">
        <h3>Test Details</h3>
        <div class="info-row">
          <span class="label">Test Name</span
          ><span class="value">{{ service.service_name }}</span>
        </div>
        <div class="info-row">
          <span class="label">Status</span>
          <span class="value" :class="statusClass">
            <span v-if="service.attended == 0" :class="statusClass"
              >Pending</span
            >
            <span v-if="service.attended == 1" :class="statusClass"
              >In Progress</span
            >
            <span v-if="service.attended == 2" :class="statusClass"
              >Completed</span
            >
          </span>
        </div>
        <div class="info-row">
          <span class="label">Time Left</span
          ><span class="value">{{ remaiming_time }}</span>
        </div>
        <div class="info-row">
          <span class="label">Progress</span
          ><span class="value">{{ percentSpent }}</span>
        </div>
        <div class="info-row">
          <span class="label">Start Time</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ local_time(specimen.created_at) || "-" }}</span
          >
          <!-- local_time(specimen.created_at) -->
        </div>
        <div class="info-row">
          <span class="label">End Time</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ formatDT(specimen.expected_completion) || "-" }}</span
          >
        </div>

        <!-- 🔹 Progress Bar -->
        <div class="progress-bar-container">
          <div
            class="progress-bar"
            :style="{ width: parseFloat(percentSpent) + '%' }"
          ></div>
        </div>
      </section>

      <!-- Technologist -->
      <section class="card">
        <h3>Technologist</h3>
        <div class="info-row">
          <span class="label">Name</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.labtech_name }}</span
          >
        </div>
        <div class="info-row">
          <span class="label">ID</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ specimen.lab_tech_id }}</span
          >
        </div>
        <div class="info-row">
          <span class="label">Email</span
          ><span
            class="value"
            v-if="specimen && (specimen.specimen_id || specimen.id)"
            >{{ technologist.email }}</span
          >
        </div>
      </section>

      <!-- Results -->
      <!-- Results -->
      <section v-if="service.attended == 2" class="card results-card">
        <h3 class="mb-3">Results</h3>

        <!-- Text Results -->
        <div class="mb-4">
          <h5 class="fw-bold mb-2">Results Notes</h5>
          <p v-if="test_results && test_results.note" class="mb-0">
            {{ test_results.note }}
          </p>
        </div>

        <!-- Tabular Results -->
        <div>
          <h5 class="fw-bold mb-2">Tabular Results</h5>
          <div class="table-responsive">
            <table class="table table-bordered table-striped align-middle mb-0">
              <thead class="table-light">
                <tr>
                  <th style="width: 30%">Parameter</th>
                  <th style="width: 20%">Result</th>
                  <th style="width: 20%">Units</th>
                  <th style="width: 30%">Reference Range</th>
                </tr>
              </thead>
              <tbody v-for="tabular in tabular_results" :key="tabular.id">
                <tr>
                  <td>{{ tabular.parameter }}</td>
                  <td>{{ tabular.result }}</td>
                  <td>{{ tabular.unit }}</td>
                  <td>{{ tabular.reference_range }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
      <!-- Report -->
      <!-- <section class="card" v-if="!showReport">
        <h3>Test Report</h3>
        <textarea
          v-model="test.report"
          placeholder="Write full lab report here..."
        ></textarea>
        <input type="file" @change="uploadReport" />
        <div class="progress-bar-container" v-if="uploading">
          <div
            class="progress-bar uploading"
            :style="{ width: uploadProgress + '%' }"
          ></div>
        </div>
      </section> -->

      <!-- Consumables -->
      <section v-if="service.attended == 2" class="card">
        <h3>Consumables Used</h3>

        <table class="consumables-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <!-- <th>Unit</th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in consumables" :key="i">
              <td>{{ item.item_name }}</td>
              <td>{{ item.quantity }}</td>
              <!-- <td>{{ item.unit }}</td> -->
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </div>
  <lab_results_modal2
    :test_id="test_id"
    :patient_identity="patient.id"
    v-if="show_test_tesult_modal"
    @close-lab-results-modal2="hide_test_tesult_modal_"
  />
  <Initiate_lab
    :test_id="test_id"
    :patient_identity="patient.id"
    :update_mode="specimen_update_mode"
    :update_data="specimen_update"
    v-if="show_initiate_lab_modal"
    @close-initiate-lab-modal="close_initiate_lab_modal"
  />
</template>

<script>
import formatDateTime from "../../../timezone/utc_local_time";
import printPDF from "../../../prints/div_to_pdf";
import Initiate_lab from "./initiate_lab_modal.vue";
import lab_results_modal2 from "./lab_results_modal2.vue";
import { generalApiRequest } from "../../../api/apiIndex";
import loader from "../../special_clinics/dialysis/loader.vue";
export default {
  name: "LabDetails",
  data() {
    return {
      show_test_tesult_modal: false,
      patient: {},
      specimen: {},
      test: {},
      technologist: {},
      opd: {},
      percentSpent: "",
      remaiming_time: "",
      tabular_results: [],
      test_results: {},
      visit: {},

      consumables: [],
      service: {},
      test_id: this.$route.params.labID,
      timeRemaining: "2h 30m",
      showReport: false,
      uploading: false,
      uploadProgress: 0,
      show_initiate_lab_modal: false,
      loading: false,
      specimen_update: {},
      specimen_update_mode: false,
    };
  },
  components: {
    lab_results_modal2,
    Initiate_lab,
    loader,
  },
  computed: {
    statusClass() {
      return {
        pending: this.test.status === "Pending",
        inprogress: this.test.status === "In Progress",
        completed: this.test.status === "Completed",
      };
    },
  },
  methods: {
    close_initiate_lab_modal() {
      this.getData();
      this.show_initiate_lab_modal = false;
      this.specimen_update_mode = false;
    },
    local_time(time) {
      return formatDateTime(time);
    },
    display_initiate_lab_update() {
      //   console.log(this.specimen.type);
      if (!this.specimen) {
        console.warn("⚠️ Specimen is null or undefined");
        this.show_initiate_lab_modal = true;
        return;
      }

      this.specimen_update_mode = true;
      var specimen_id = this.specimen.specimen_id || this.specimen.id;
      this.specimen_update = {
        id: this.specimen.id,
        specimen_id: specimen_id,
        category: this.specimen.category,
        type: this.specimen.type,
        collection_date: this.specimen.collection_date,
        condition: this.specimen.condition,
        collector: this.specimen.collector,
        storage: this.specimen.storage,
        expected_duration: this.specimen.expected_duration,
        expected_completion: this.toDatetimeLocalFormat(
          this.specimen.expected_completion,
        ),
        remarks: this.specimen.remarks,
        selectedCondition: this.specimen.condition,
      };
      this.show_initiate_lab_modal = true;
    },
    toDatetimeLocalFormat(isoString) {
      const date = new Date(isoString);
      if (isNaN(date)) return "";

      // Get local ISO string and trim seconds, milliseconds, and Z
      const isoLocal = date.toISOString().slice(0, 16);
      return isoLocal;
    },
    display_initiate_lab_modal() {
      this.show_initiate_lab_modal = true;
    },
    printReport() {
      printPDF("printable_div", "Lab_report", "portrait");
    },
    show_test_tesult_modal_() {
      this.show_test_tesult_modal = true;
    },
    async hide_test_tesult_modal_() {
      await this.getData();
      this.show_test_tesult_modal = false;
    },
    startTest() {
      this.test.status = "In Progress";
      this.test.progress = 20;
      this.test.startTime = new Date().toLocaleString();
      let interval = setInterval(() => {
        if (this.test.progress < 90 && this.test.status === "In Progress") {
          this.test.progress += 10;
        } else {
          clearInterval(interval);
        }
      }, 1000);
    },
    completeTest() {
      this.test.status = "Completed";
      this.test.progress = 100;
      this.test.endTime = new Date().toLocaleString();
    },
    saveResults() {
      alert("Results saved:\n" + this.test.results);
    },
    addReport() {
      this.showReport = true;
    },
    uploadReport(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploading = true;
        this.uploadProgress = 0;
        let interval = setInterval(() => {
          if (this.uploadProgress < 100) {
            this.uploadProgress += 20;
          } else {
            clearInterval(interval);
            this.uploading = false;
            alert("Report uploaded: " + file.name);
          }
        }, 500);
      }
    },
    goBack() {
      this.$router.push("/consultation_at_lab/" + this.service.visit_id);
    },
    async getData() {
      this.loading = true;
      const url = `get_lab_details_data/${this.test_id}`;
      try {
        const response = await generalApiRequest(url, "GET", {}, 1);
        console.log(response.test_results);

        this.patient = response.patient;
        this.specimen = response.specimen;
        this.service = response.service;
        this.technologist = response.technologist;
        this.opd = response.opd;
        this.consumables = response.consumables;
        this.tabular_results = response.tabular_results;
        this.test_results = response.test_results;
        this.visit = response.visit;

        this.loading = false;
        //
        setInterval(() => {
          this.getLabTestProgress(
            this.specimen.created_at,
            parseFloat(this.specimen.expected_duration),
          );
        }, 4000);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    },

    formatDT(isoString) {
      const date = new Date(isoString);
      if (isNaN(date)) return null;

      return date.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    },

    getLabTestProgress(startDateTime, durationHours) {
      // Ensure valid ISO format (add 'Z' if missing)
      if (typeof startDateTime === "string" && !startDateTime.endsWith("Z")) {
        startDateTime += "Z";
      }

      const start = new Date(startDateTime);
      if (isNaN(start)) {
        console.error("❌ Invalid startDateTime:", startDateTime);
        return null;
      }

      const totalDurationMs = durationHours * 60 * 60 * 1000;
      const end = new Date(start.getTime() + totalDurationMs);

      const now = new Date();
      const elapsedMs = Math.min(Math.max(now - start, 0), totalDurationMs);
      const remainingMs = totalDurationMs - elapsedMs;

      const remainingHours = Math.floor(remainingMs / (1000 * 60 * 60));
      const remainingMinutes = Math.floor(
        (remainingMs % (1000 * 60 * 60)) / (1000 * 60),
      );

      const percentSpent = ((elapsedMs / totalDurationMs) * 100).toFixed(2);

      this.specimen = {
        ...this.specimen,
        expected_completion: isNaN(end) ? null : end.toISOString(),
      };

      this.remaiming_time = `${remainingHours}h ${remainingMinutes}m`;
      this.percentSpent = `${percentSpent}%`;

      return {
        expectedCompletion: isNaN(end) ? null : end.toISOString(),
        remaining: `${remainingHours}h ${remainingMinutes}m`,
        percentSpent: `${percentSpent}%`,
      };
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style scoped>
.results-card {
  grid-column: 1 / -1; /* span full width of the grid */
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.lab-details-container {
  font-family: Arial, sans-serif;
  padding: 0;
}

/* Patient biodata card full width */
.patient-card {
  margin: 10px 15px;
}

.action-bar {
  position: sticky;
  top: 0;
  background: #1976d2;
  padding: 8px;
  display: flex;
  gap: 8px;
  margin: 0 15px 15px;
  border-radius: 6px;
}

.action-bar button {
  background: white;
  border: none;
  padding: 6px 12px;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
}
.action-bar button:hover {
  background: #f0f0f0;
}

.grid-layout {
  padding: 0 15px 15px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  grid-gap: 15px;
}

.card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 12px 15px;
  font-size: 13px;
}

.card h3 {
  margin-bottom: 10px;
  font-size: 15px;
  color: #1976d2;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 4px 0;
  border-bottom: 1px solid #f1f1f1;
}
.info-row:last-child {
  border-bottom: none;
}
.label {
  font-weight: bold;
  color: #555;
}
.value {
  color: #333;
  text-align: right;
}

textarea {
  width: 100%;
  min-height: 80px;
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 8px;
  font-size: 13px;
}

.progress-bar-container {
  background: #eee;
  border-radius: 4px;
  height: 8px;
  margin-top: 8px;
  overflow: hidden;
}
.progress-bar {
  height: 8px;
  background: #1976d2;
  transition: width 0.3s ease;
}
.progress-bar.uploading {
  background: #4caf50;
}

.pending {
  color: orange;
  font-weight: bold;
}
.inprogress {
  color: blue;
  font-weight: bold;
}
.completed {
  color: green;
  font-weight: bold;
}
.patient-card {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px 20px;
  margin-bottom: 15px;
  font-size: 14px;
}

.patient-card h3 {
  margin-bottom: 12px;
  color: #1976d2;
  font-size: 16px;
}

.biodata-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 10px 20px;
}

.biodata-item {
  display: flex;
  justify-content: space-between;
  padding: 6px 10px;
  background: #f9f9f9;
  border-radius: 6px;
}

.biodata-item .label {
  font-weight: bold;
  color: #444;
}

.biodata-item .value {
  color: #222;
  text-align: right;
}

/* ============================================== */
.test-header {
  margin: 0 15px 10px;
  background: #e3f2fd;
  border-left: 4px solid #1976d2;
  border-radius: 6px;
  padding: 10px 15px;
}

.test-header h2 {
  font-size: 18px;
  color: #0d47a1;
  margin-bottom: 5px;
}

.test-meta {
  font-size: 13px;
  color: #444;
}
</style>
